import { dataDetails, dataDetailsFiltered, filterBrandTitle } from "../../../@signals";

export default function useShareOfSearchSharePercentageGraphFilterData() {

    const handleFilterBrand = (name, id) => {
		if (!dataDetailsFiltered.value.length)
			dataDetailsFiltered.value = dataDetails.value
		else
			dataDetails.value = dataDetailsFiltered.value

		filterBrandTitle.value = name

		dataDetails.value = [...dataDetails.value].filter(item => item.brandID === id)

	}

    const handleFilterRemaining = remainingData => {
        if (!dataDetailsFiltered.value.length)
			dataDetailsFiltered.value = dataDetails.value
		else
			dataDetails.value = dataDetailsFiltered.value

            filterBrandTitle.value = 'Remaining'

        const remainingBrands = remainingData.map((item) => item.name)

        dataDetails.value = [...dataDetails.value].filter(item => remainingBrands.includes(item.brand))
	}



	return {
        handleFilterBrand,
        handleFilterRemaining
	}
}